import { render, staticRenderFns } from "./WarningButton.vue?vue&type=template&id=4cc10b1c&"
import script from "./WarningButton.vue?vue&type=script&lang=js&"
export * from "./WarningButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports